/* This file is generated by createIcons.js any changes will be lost. */
import createIcon from '../createIcon';
export const ChartPieIconConfig = {
  name: 'ChartPieIcon',
  height: 512,
  width: 544,
  svgPath: 'M527.79 288H290.5l158.03 158.03c6.04 6.04 15.98 6.53 22.19.68 38.7-36.46 65.32-85.61 73.13-140.86 1.34-9.46-6.51-17.85-16.06-17.85zm-15.83-64.8C503.72 103.74 408.26 8.28 288.8.04 279.68-.59 272 7.1 272 16.24V240h223.77c9.14 0 16.82-7.68 16.19-16.8zM224 288V50.71c0-9.55-8.39-17.4-17.84-16.06C86.99 51.49-4.1 155.6.14 280.37 4.5 408.51 114.83 513.59 243.03 511.98c50.4-.63 96.97-16.87 135.26-44.03 7.9-5.6 8.42-17.23 1.57-24.08L224 288z',
  yOffset: '',
  xOffset: '',
  transform: ''
};
export default createIcon(ChartPieIconConfig);